import {
  CloseCircleOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  PaperClipOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Input,
  Modal,
  Select,
  Table,
  Typography,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { isEmpty, isNumber } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx/xlsx.mjs";
import API from "../../api/backend/machineManagement";
import { KEY, lang, MODE_SCREEN, STYLE } from "../../constants/common.const";
import { MSG_CATCH, showMessage } from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classPopup from "../../models/control/popup";
import { ButtonModalClassification } from "./buttonModalClassification";
import { getIconByFileType, isEmptyData } from "../../utils/helper";
const { Text } = Typography;

const EquipmentMaintainceHistory = ({
  mode = MODE_SCREEN.VIEW,
  data = {},
  dataSource: listMaintenance = [],
  setDataSource: setListMaintenance = () => {},
  clickSave,
  ddlClassification,
  setDdlClassification,
  setIsDirty,
  currentGene
}) => {
  const fileElUpload = useRef(null);
  const fileEl = useRef(null);

  const { allowRoute, roles } = useSelector((state) => state.auth);
  const [popupAttach, setPopupAttach] = useState(new classPopup());
  const [urlTemplate, setUrlTemplates] = useState();
  const [listAttachMachine, setListAttachMachine] = useState([]);
  const [modal_attach_data, set_modal_attach_data] = useState([]);

  const isViewMode = mode === MODE_SCREEN.VIEW;
  const handleDeleteRowMaintaince = (key) => {
    const newListAttachMachine = listMaintenance.filter((item) => {
      return item.key !== key;
    });
    setListMaintenance(newListAttachMachine);
    setIsDirty(true)
  };
  const isError = (data, { generationNumber,listAttachment, ...row }) => {
    return (
      isEmptyData(data) &&
      clickSave &&
      (filterEmptyDataSource(row) ||
        (Array.isArray(listAttachment) && listAttachment.length !== 0))
    );
  };

  const getGene = () => {
  if(mode === MODE_SCREEN.ADD)return 1;
  return currentGene
  }
  const handleAddRowMaintaince = (item) => {
    const key = Date.now();
    const newRow = {
      machineForSiteOfficeCode: "",
      dateImplementation: "",
      division: "",
      overview: "",
      workContent: "",
      contractor: "",
      ...(item || {}),
      listAttachment: [],
      key,
      id: null,
      generationNumber:getGene()
    };
    setListMaintenance([newRow,...listMaintenance]);
  };
  const onChangeMaintaince = (key, nameColums, newValue) => {
    const index = listMaintenance.findIndex((item) => item.key === key);
    const newObject = {
      [nameColums]: newValue,
    };

    const newDataSource = [
      ...listMaintenance.slice(0, index),
      { ...listMaintenance[index], ...newObject },
      ...listMaintenance.slice(index + 1),
    ];
    setListMaintenance(newDataSource);
    setIsDirty(true)
  };
  const isCustomer = roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER";

  const fetchClassification = async (value) => {
    try {
      const res = await API.getClassification();
      if (res && !isEmpty(res.data)) {
        setDdlClassification({
          ...ddlClassification,
          options: res.data.map((item) => ({
            ...item,
            label: item.classification,
            value: item.id,
          })),
        });
      }
    } catch (e) {}
  };
  const uploadFile = async (file, type) => {
    const formData = new FormData();
    const body = {
      attachFileName: file.name,
      type: type,
    };
    formData.append("data", JSON.stringify(body));
    formData.append("file", file);

    try {
      const res = await API.uploadFile(formData);
      const newListAttachMachine = [...listAttachMachine];
      if (type == 1) {
        newListAttachMachine.push(res.data);
        setListAttachMachine([...newListAttachMachine]);
      }

      return res.data;
    } catch (err) {
      showMessage(
        KEY.ERROR,
        (err.response && err.response.data.msg) || MSG_CATCH()
      );
    }
  };
  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        const newListAttachMachine = json
          .filter((item) => {
            if (
              !item[lang.MAINTAINCE_DATE] &&
              !item[lang.MAINTAINCE_DIVISION] &&
              !item[lang.MAINTAINCE_OVERVIEW] &&
              !item[lang.MAINTAINCE_WORK_CONTENT] &&
              !item[lang.MAINTAINCE_PIC]
            )
              return false;
            return true;
          })
          .map((item, index) => {
            const key = Date.now() + index;
            const thisContractor = ddlClassification.options.find((x) => {
              return x.label === item[lang.MAINTAINCE_PIC];
            });
            return {
              key,
              machineForSiteOfficeCode: "",
              dateImplementation: item[lang.MAINTAINCE_DATE]
                ? moment(item[lang.MAINTAINCE_DATE])
                : null,
              division: item[lang.MAINTAINCE_DIVISION],
              overview: item[lang.MAINTAINCE_OVERVIEW],
              workContent: item[lang.MAINTAINCE_WORK_CONTENT],
              contractor: thisContractor ? thisContractor.value : null,
              listAttachment: [],
              generationNumber:getGene()
            };
          });
        if (isEmpty(newListAttachMachine)) {
          showMessage(
            KEY.ERROR,
            "入力ファイルのフォーマットが間違っているので、確認してください。"
          );
          return;
        }
        setListMaintenance(
          [...listMaintenance.filter(filterEmptyDataSource)].concat(
            newListAttachMachine
          )
        );
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
    fileElUpload.current.value = null;
  };
  const filterEmptyDataSource = (dataSource) => {
    return !Object.values({ ...dataSource, key: null, id: null }).every(
      (value) => !value || isEmpty(value)
    );
  };
  useEffect(() => {
    const getUrlTemplate = async () => {
      const res = await API.downloadTemplateMachineMaintenance();
      // saveFile(res);
      setUrlTemplates(res.data);
    };
    getUrlTemplate();
  }, []);
  useEffect(() => {
    if (!isNumber(popupAttach.show)) {
      return;
    }
    const current_maintenance = listMaintenance.find(
      (x) => x.key == popupAttach.show
    );
    set_modal_attach_data([...current_maintenance.listAttachment]);
  }, [listMaintenance, popupAttach.show]);
  async function readAttachFileUrl(e) {
    const file = e.target.files[0];
    if (!file) return;
    const fileRes = await uploadFile(file, 4);

    const newListAttachMachine = [...listMaintenance];
    const this_maintenance = newListAttachMachine.find(
      (x) => x.key == popupAttach.show
    );
    this_maintenance.listAttachment.push(fileRes);

    setListMaintenance(newListAttachMachine);
    fileEl.current.value = null;
  }
  function getSortText(text, maxLength = 10) {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }
  function FileAttachment({ item, index, noIcon = false }) {
    const name = item.attachFileName.split(".");
    const fileType = name.pop();
    return (
      <li
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom:10
        }}
        key={index}
      >
        <div>{!noIcon && getIconByFileType(item.attachFileName)}</div>
        <a
          href={item.attachFileUrl}
          title={item.attachFileName}
          style={{ display: "flex", flex: 1 }}
          target="_blank"
        >
          <p className="text-1line mb0">{getSortText(name[0],10)}</p>
          <span>.{fileType}</span>
        </a>
      </li>
    );
  }

  const column_maintaince_history = [
    !isViewMode && {
      title: " ",
      dataIndex: "delete",
      width: "5%",
      align: "center",
      render: (_, row) => (
        <Button
         disabled={row.isUsed}
          hidden={isCustomer}
          style={{ background: "#f7f9fc" }}
          onClick={() => handleDeleteRowMaintaince(row.key)}
          icon={<DeleteOutlined />}
        />
      ),
    },
    {
      title: "世代番号",
      dataIndex: "generationNumber",
      width: 100,
      align: "center",
      type:"number"
    },

    {
      title: (
        <span
          style={{
            color: "#ff2255",
          }}
        >
          {lang.MAINTAINCE_DATE}
        </span>
      ),
      dataIndex: "dateImplementation",
      key: "dateImplementation",
      width: "165px",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{_ ? moment(_).format("YYYY/MM/DD") : ""}</span>
        ) : (
          <DatePicker
            format={KEY.DATE_DEFAULT}
            value={moment(_).isValid() ? moment(_) : null}
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
            disabled={isCustomer}
            disabledDate={(current) => current > moment().endOf("day")}
            placeholder=""
            onChange={(v) =>
              onChangeMaintaince(row.key, "dateImplementation", v)
            }
          />
        ),
    },

    {
      title: lang.MAINTAINCE_DIVISION,
      key: "division",
      width: "15%",
      dataIndex: "division",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{_}</span>
        ) : (
          <Input
            value={_}
            disabled={isCustomer}
            onChange={(e) =>
              onChangeMaintaince(row.key, "division", e.target.value)
            }
          />
        ),
    },

    {
      title: (
        <>
          <span style={{ color: "#ff2255" }}>{lang.MAINTAINCE_PIC}</span>
          {!isViewMode && (
            <ButtonModalClassification
              callback={fetchClassification}
              disabled={isCustomer}
            />
          )}
        </>
      ),
      key: "contractor",
      width: "15%",
      dataIndex: "contractor",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{row.contractorValue}</span>
        ) : (
          <Select
            disabled={isCustomer}
            onChange={(value) =>
              onChangeMaintaince(row.key, "contractor", value)
            }
            value={_}
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
          >
            {ddlClassification.options.map((item) => (
              <Select.Option key={item.id} value={item.value}>
                <div
                  className="mr8"
                  style={{
                    width: 14,
                    height: 14,
                    borderRadius: "50%",
                    backgroundColor: item.color,
                    display: "inline-block",
                  }}
                ></div>
                {item.classification}
              </Select.Option>
            ))}
          </Select>
        ),
    },

    {
      title: (
        <span style={{ color: "#ff2255" }}>{lang.MAINTAINCE_OVERVIEW}</span>
      ),
      key: "overview",
      dataIndex: "overview",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{_}</span>
        ) : (
          <Input
            disabled={isCustomer}
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
            value={_}
            onChange={(e) =>
              onChangeMaintaince(row.key, "overview", e.target.value)
            }
          />
        ),
    },

    {
      title: (
        <span style={{ color: "#ff2255" }}>{lang.MAINTAINCE_WORK_CONTENT}</span>
      ),
      key: "workContent",
      dataIndex: "workContent",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{_}</span>
        ) : (
          <TextArea
            disabled={isCustomer}
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
            rows={1}
            value={_}
            onChange={(e) =>
              onChangeMaintaince(row.key, "workContent", e.target.value)
            }
          />
        ),
    },

    {
      title: lang.ATTACH,
      dataIndex: "listAttachment",
      key: "listAttachment",
      width: isViewMode ? "20%" : "105px",
      align: isViewMode ? "left" : "center",

      render: (listAttachment, row) =>
        isViewMode ? (
          <ul
            className="mb0"
            style={{ listStyle: "none", paddingLeft: "40px" }}
          >
            {listAttachment.map((item, index) => {
              return <FileAttachment item={item} index={index} key={index} />;
            })}
          </ul>
        ) : (
          <Button
            disabled={isCustomer}
            className="buttonPC button--outline --todo-- wAuto"
            onClick={() => {
              setPopupAttach({ ...popupAttach, show: row.key });
            }}
          >
            {listAttachment.length} <PaperClipOutlined className="orange " />
          </Button>
        ),
    },
  ].filter(Boolean);
  const columnsAttach = [
    {
      title: "No",
      render: (_, _2, index) => {
        return <div className="center">{++index}</div>;
      },
    },
    {
      title: "プレビュー",
      dataIndex: "attachFileUrl",
      render: (url, row) => {
        return (
          <div className="center">
            <a href={url} title={row.attachFileName}>
              <PaperClipOutlined className="blue iconM" />
            </a>
          </div>
        );
      },
    },
    {
      title: "ファイル名",
      dataIndex: "attachFileName",
      render: (text) => {
        return <Text>{text}</Text>;
      },
    },
    {
      title: "削除",
      align: "center",
      render: (_, row) => {
        return (
          <DeleteOutlined
            disabled={isCustomer}
            className="iconM red"
            onClick={() => {
              const list = [...modal_attach_data].filter(
                (item) => item.attachFileUrl !== row.attachFileUrl
              );
              const new_list_maintenance = [...listMaintenance];
              const this_maintenance = new_list_maintenance.find(
                (x) => x.key == popupAttach.show
              );
              this_maintenance.listAttachment = list;

              setListMaintenance(new_list_maintenance);
            }}
          />
        );
      },
    },
  ];
  return (
    <div>
        {mode !== MODE_SCREEN.VIEW && (
        <div className="mt8">
          <Button
            hidden={roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER"}
            style={{
              background: "#f7f9fc",
              width: "auto",
              minWidth: "auto",
            }}
            className="pr10 pl10 mt4 mb4 ml10"
            onClick={() => handleAddRowMaintaince()}
            icon={<PlusOutlined />}
          ></Button>
          <Button
            hidden={roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER"}
            style={{
              background: "#f7f9fc",
              width: "auto",
              minWidth: "auto",
              color: "#0080cb",
            }}
            className="pr10 pl10 mt4 mb4 ml10"
            onClick={() => {
              fileElUpload.current.click();
            }}
            icon={
              <CloudUploadOutlined
                style={{
                  color: "#f50",
                }}
              />
            }
          >
            保全履歴入力
          </Button>
          <a href={urlTemplate} className="ml4">
            <Button
              hidden={roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER"}
              style={{
                background: "#f7f9fc",
                width: "auto",
                minWidth: "auto",
                color: "#0080cb",
              }}
              className="pr10 pl10 mt4 mb4 ml10"
              icon={
                <CloudDownloadOutlined
                  style={{
                    color: "#f50",
                  }}
                />
              }
            >
              {lang.MAINTAINCE_TEMPLATE}
            </Button>
          </a>
          <input
            type="file"
            className="d-none"
            ref={fileElUpload}
            onChange={readUploadFile}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
        </div>
      )}
      <Table
        scroll={!isEmpty(listMaintenance) && { y: 220, x: 768 }}
        locale={{
          emptyText: "",
        }}
        pagination={false}
        dataSource={listMaintenance}
        className="tableAddMachine"
        columns={column_maintaince_history}
      />
    
      <Modal
        centered
        width="40%"
        bodyStyle={{ height: "400px", overflow: "auto" }}
        closeIcon={<></>}
        className="modal-msg modal-padding"
        title={<div className="center">{lang.ATTACH}</div>}
        visible={isNumber(popupAttach.show)}
        footer={[
          <Button
            key={1}
            className="buttonPC button--outline --todo-- wAuto"
            onClick={() => {
              setPopupAttach({ ...popupAttach, show: false });
            }}
          >
            <CloseCircleOutlined />
            {lang.CLOSE}
          </Button>,
        ]}
      >
        <div className="mb15">
          新規挿入:
          <Button
            type="link"
            onClick={() => {
              fileEl.current.click();
            }}
          >
            <PaperClipOutlined className="iconM blue" />
          </Button>
        </div>
        <input
          type="file"
          className="d-none"
          ref={fileEl}
          onChange={readAttachFileUrl}
        />
        {
          <Table
            className="tbl-original"
            rowKey="ItemOrder"
            dataSource={modal_attach_data}
            columns={columnsAttach}
            pagination={false}
            bordered
          />
        }
      </Modal>
    </div>
  );
};

export default EquipmentMaintainceHistory;
